import React from 'react';
import { PlusIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface FABProps {
  onClick: () => void;
  label: string;
  colorClassName?: string;
}
export function FAB({
  onClick,
  label,
  colorClassName = 'bg-teal-600 hover:bg-teal-700'
}: FABProps) {
  return <motion.button type="button" onClick={onClick} aria-label={label} whileTap={{
    scale: 0.92
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} className={`absolute bottom-5 right-5 z-20 flex h-14 w-14 items-center justify-center rounded-full text-white shadow-lg shadow-slate-900/15 transition-colors duration-150 ${colorClassName}`} data-id="element-146" data-mp="h3qa6mczcegc">
      <PlusIcon className="h-6 w-6" strokeWidth={2.5} data-id="element-147" data-mp="102cba18hy5k9" />
    </motion.button>;
}